angular.module('picmonicng').filter('pathwaysDurationTime', [
  function () {
    return function (numberOfCards) {
      var estimatedTimeMinutes = numberOfCards / 2;
      var estimatedTimeHours = estimatedTimeMinutes / 60;
      var returnValue = null;

      if (estimatedTimeHours <= 1) {
        if (estimatedTimeHours == 1) {
          returnValue = '1 Hour';
        } else {
          returnValue = parseInt(estimatedTimeHours * 60) + ' Minutes';
        }
      } else {
        if (estimatedTimeMinutes % 60) {
          returnValue = parseInt(estimatedTimeHours) + ' Hours ' + parseInt(estimatedTimeMinutes % 60) + ' Minutes';
        } else {
          returnValue = parseInt(estimatedTimeHours) + ' ' + (estimatedTimeHours > 1 ? 'Hours' : 'Hour');
        }
      }
      return returnValue;
    };
  },
]);
